// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    createFilterOptions,
    Input,
    InputLabel,
    Select, TextField
} from "@mui/material";

// App Imports

import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";


import {getAllDataPoints} from "../DataPoint/DataPointClient";


import {changeDataPointXref} from "./dataPointXrefSlice";
import {addDataPointAttribute, getAllDataPointAttributes} from "../DataPointAttribute/DataPointAttributeClient";
import {addDataPointXref, editDataPointXref} from "./DataPointXrefClient";
import {Autocomplete} from "@mui/lab";


// Main Function
export default function DataPointXrefDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorXrefId = useSelector((state) => state.dataPointXrefSlc.value.id);
    const selectorDataPointId = useSelector((state) => state.dataPointXrefSlc.value.dataPointId);
    const selectorXrefDrawerState = useSelector((state) => state.dataPointXrefSlc.value.xrefDrawerState);
    const selectorXrefDrawerMode = useSelector((state) => state.dataPointXrefSlc.value.xrefDrawerMode);
    const drawerModeRef = React.useRef(selectorXrefDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const { register, handleSubmit,setValue,  control, formState: { errors } } = useForm();
    // const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Xref data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorXrefDrawerMode==="Add"){
            addDataPointXref(data)
                .then(() => {
                    console.log("Xref added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointXref({
                    id: null, dataPointId: null, attributeId: null,ordinalNumber: null,
                    xrefStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    attributeCode:null, attributeName: null, category: null, attributeStatus: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    xrefGridRefresh: true, xrefDrawerState: false, xrefDrawerMode: null}))
            })}
        if(selectorXrefDrawerMode==="Clone"){
            const { id, ...clonedData } = data; // removes id
            addDataPointXref(clonedData)
                .then(() => {
                    console.log("Xref cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Clone added"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointXref({
                    id: null, dataPointId: null, attributeId: null, ordinalNumber: null,
                    xrefStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    attributeCode:null, attributeName: null, category: null, attributeStatus: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    xrefGridRefresh: true, xrefDrawerState: false, xrefDrawerMode: null}))
            })}
        if(selectorXrefDrawerMode==="Edit"){
            console.log("This is the contractDataPoint Id I am going to edit")
            console.log(selectorXrefId)
            editDataPointXref(selectorXrefId, data)
                .then(() => {
                    console.log("ContractDataPoint edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeDataPointXref({
                    id: null, dataPointId: null, attributeId: null, ordinalNumber: null,
                    xrefStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    attributeCode:null, attributeName: null, category: null, attributeStatus: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    xrefGridRefresh: true, xrefDrawerState: false, xrefDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeXrefDrawer() {
        dispatchData(changeDataPointXref({
            id: null, dataPointId: null, attributeId: null, ordinalNumber: null,
            xrefStatus: null,
            dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
            attributeCode:null, attributeName: null, category: null, attributeStatus: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            xrefGridRefresh: true, xrefDrawerState: false, xrefDrawerMode: null}));

        dispatchData(changeDataPointXref({xrefDrawerState: false }));
    };


    const filter = createFilterOptions({
        stringify: (option) => option.name || ""
    });
    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchAttributesForDropdowns = () =>
        getAllDataPointAttributes()

            .then(data => {
                console.log("Attributes List")
                console.log(data);
                setAttributes(data);
            })
    useEffect(() => {
        console.log("This is for the attributes dropdown...");
        fetchAttributesForDropdowns();
    }, []);

    const fetchDataPointsForDropdowns = () =>
        getAllDataPoints()

            .then(data => {
                console.log("Data Points List")
                console.log(data);
                setDataPoints(data);

            })
    useEffect(() => {
        console.log("This is for the data points dropdown...");
        fetchDataPointsForDropdowns();
    }, []);




// *********************** END DROPDOWNS **************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);

    const handleDataPointChange = (dataPointEvent) => {
        console.log("handleDataPointChange triggered by ", dataPointEvent);
        // setSelectedDataPoint(dataPointEvent);
        dispatchData(changeDataPointXref({dataPointId: dataPointEvent}));
        console.log("This is for the selected Value");
        console.log(dataPointEvent);
    };

    useEffect(() => {
        const existingValue = selectorDataPointId;
        setValue('dataPoint.id', existingValue ? existingValue : null);
    }, [selectorDataPointId, setValue]);

    // ****************** BEGIN FORM ****************************

    function xrefForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeXrefDrawer()}>Data Point Xref Form</h2>
                    <h4>{selectorXrefDrawerMode} Mode</h4>
                    <br/>
                    <br/>

                    {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>*/}
                    {/*    <InputLabel htmlFor="dataPoint.id">Data Point</InputLabel>*/}
                    {/*    <Select*/}

                    {/*        {...register('dataPoint.id', { required: true })}*/}
                    {/*        labelId="dataPoint.id"*/}
                    {/*        id="dataPoint.id"*/}
                    {/*        label="dataPoint.id"*/}
                    {/*        defaultValue=        {useSelector((state) => state.dataPointXrefSlc.value.dataPointId)}*/}
                    {/*        sx={{ width: 300 }}*/}
                    {/*    >*/}
                    {/*        {dataPoints.map((DataPointItem) =>*/}
                    {/*            <MenuItem value={DataPointItem.id}>{DataPointItem.name}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*</FormControl>*/}
                    <Autocomplete
                        disablePortal
                        disableCloseOnBlur
                        ListboxProps={{
                            style: {
                                maxHeight: 400,  // <-- make the listbox longer
                            },
                            onClick: (event) => {
                                event.stopPropagation();
                            }
                        }}

                        labelId="dataPoint.id"
                        id="dataPointId"
                        options={dataPoints}
                        // getOptionLabel={(option) => option.name}
                        // getOptionLabel={(option) => option && option.name ? option.name : ""}
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === 'number' || typeof option === 'string') {
                                const found = dataPoints.find(dp => dp.id === parseInt(option));
                                return found && found.name ? found.name : "";
                            }
                            return option && option.name ? option.name : "";
                        }}
                        // filterOptions={(options, state) => {
                        //     return options.filter(option => {
                        //         const name = option && option.name ? option.name : "";
                        //         return name.toLowerCase().includes(state.inputValue.toLowerCase());
                        //     });
                        // }}
                        filterOptions={filter}
                        isOptionEqualToValue={(option, value) => option && value ? option.id === value.id : option === value}
                        // isOptionEqualToValue={(option, value) => option && value ? option.id === '999999' : option === value}
                        // isOptionEqualToValue={() => false}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        // isOptionEqualToValue={(option, value) =>
                        //     option && value ? option.id === value.id : option === value}
                        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}
                        // value={dataPoints.find(dp => dp.id === parseInt(selectorContractDataPointId))}
                        // value={selectorDataPointId || null}
                        value={dataPoints.find(dp => dp.id === parseInt(selectorDataPointId)) || null}
                        onChange={(event, newValue) => {
                            setSelectedDataPoint(newValue);
                            setValue('dataPoint.id', newValue ? newValue.id : null, { shouldValidate: true });
                            console.log("onChange triggered in Data Point dropddown");
                            handleDataPointChange(newValue ? newValue.id : null);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                            console.log("onInputChange triggered", newInputValue, reason);
                        }}
                        onHighlightChange={(event, option, reason) => {
                            console.log("onHighlightChange triggered", option, reason);
                        }}
                        sx={{width: 600}}
                        renderInput={(params) => <TextField {...params} label="Data Point" variant="standard"/>}
                        // ListboxComponent={ListboxComponent}
                    />
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', { required: true })}
                        id="id" name="id"  label="id" aria-describedby="id_entry"
                        defaultValue=        {Number(useSelector((state) => state.dataPointXrefSlc.value.id))}
                    />
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <InputLabel htmlFor="attributeId">Attribute</InputLabel>
                        <Select

                            {...register('attributeId', { required: true })}
                            labelId="attributeId"
                            id="attributeId"
                            label="attributeId"
                            defaultValue=        {useSelector((state) => state.dataPointXrefSlc.value.attributeId)}
                            sx={{ width: 300 }}
                        >
                            {attributes.map((AttributeItem) =>
                                <MenuItem value={AttributeItem.id}>{AttributeItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="ordinalNumber">Order</InputLabel>
                    <Input
                        {...register('ordinalNumber', {required: false})}
                        id="ordinalNumber" name="ordinalNumber" label="Order" aria-describedby="ordinalNumber_entry"
                        defaultValue={useSelector((state) => state.dataPointXrefSlc.value.ordinalNumber)}
                        sx={{width: 100}}/>
                    {/*<FormHelperText id="name_helper">enter the Order</FormHelperText>*/}
                    <br/>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeXrefDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorXrefDrawerState}
                onClose={closeXrefDrawer}
            >
                {xrefForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
